import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {media} from "./theme.js";
import Component from "./editable-component.js";
import Image from "./image.js";
import {useSearchParams} from "../common/hooks.js";
export default function ThumbnailSlider(props) {
  const {images, color = "transparent", ...rest} = props;
  const [qs, setQs] = useSearchParams();
  const len = images.length;
  const imageSliderIndex = qs.image_slider_index ? Math.max(0, Math.min(Number(qs.image_slider_index) - 1, len - 1)) : 0;
  if (images.length === 1) {
    const [image] = images;
    return /* @__PURE__ */ React.createElement(Component, {
      ...rest
    }, /* @__PURE__ */ React.createElement(ImageContainer, {
      style: {"--background-color": color, "--ratio": "66.66666%"}
    }, /* @__PURE__ */ React.createElement(HeroImage, {
      visible: true,
      ...image,
      sizes: [750, 450]
    })));
  }
  return /* @__PURE__ */ React.createElement(Component, {
    ...rest
  }, /* @__PURE__ */ React.createElement(ThumbnailSliderGrid, null, /* @__PURE__ */ React.createElement(ThumbnailContainer, {
    style: {"--highlight-color": color}
  }, images.map((image, i) => {
    return /* @__PURE__ */ React.createElement(ThumbContainer, {
      key: i,
      active: imageSliderIndex === i,
      onClick: () => {
        setQs({image_slider_index: i + 1});
      }
    }, /* @__PURE__ */ React.createElement(Thumb, {
      ...image,
      sizes: [80]
    }));
  })), /* @__PURE__ */ React.createElement(ImageContainer, {
    style: {"--background-color": color, "--ratio": "66.66666%"}
  }, images.map((image, i) => {
    return /* @__PURE__ */ React.createElement(HeroImage, {
      key: i,
      visible: imageSliderIndex === i,
      ...image,
      sizes: [750, 450]
    });
  }))));
}
const ThumbnailSliderGrid = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 80px 1fr;
  grid-template-rows: 1fr;
  grid-gap: 0px 24px;
  grid-template-areas: "thumbnails image";

  ${media.mobile} {
    margin-top: 0;
  }

  ${media.phone} {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    grid-gap: 24px 0px;
    grid-template-areas:
      "image"
      "thumbnails";
  }
`;
const HeroImage = styled(Image)`
  display: ${({visible}) => visible ? "block" : "none"};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const ThumbnailContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: thumbnails;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  ${media.phone} {
    flex-direction: row;
  }
`;
const ImageContainer = styled.div`
  background-color: var(--background-color);
  grid-area: image;
  display: flex;
  flex-grow: 1;
  border-radius: 6px;
  position: relative;
  padding-bottom: var(--ratio);
  overflow: hidden;
  border: 2px solid #eee;
`;
const ThumbContainer = styled.div`
  overflow: hidden;
  border-radius: 4px;
  height: 55px;
  margin-bottom: 16px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s ease;

  ${({active}) => active && `border: 2px solid var(--highlight-color);`};

  &:hover {
    border: 2px solid var(--highlight-color);
  }

  ${media.phone} {
    height: calc(90vw / 5);
    width: calc(90vw / 5);
    flex-shrink: 0;
    flex-grow: 0;
    margin-bottom: 0;
    margin-right: 8px;
  }
`;
const Thumb = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
